import {Component, OnInit, TemplateRef} from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {BsModalRef, BsModalService} from 'ngx-bootstrap/modal';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {TSFuntionService} from '../../services/ts-funtion.service';
import {DecimalPipe} from '@angular/common';
import {SWAlertService} from '../../services/swalert.service';
import {Router} from '@angular/router';
import * as XLSX from 'xlsx';
import * as _ from 'lodash';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-admin-payment-doc-import',
  templateUrl: './admin-payment-doc-import.component.html',
  styleUrls: ['./admin-payment-doc-import.component.css']
})
export class AdminPaymentDocImportComponent implements OnInit {

  // Declare variable
  // Form control
  sPaymentDocFrom = new FormGroup({
    sPaymentDocRowNum :  new FormControl(''),
    sPaymentDocReqID : new FormControl(''),
    sPaymentDocReqCode : new FormControl(''),
    sPaymentDoc: new FormControl('', Validators.required),
  });
  fileName = '';
  modalRef: BsModalRef;
  ColumnsData = [
    {
      ColumnName: 'Year',
      Value: 'nYear',
      Section: 1,
      show: 'n',
      SortField: 'nYear',
      Width: '4%',
      Align: 'center',
      Decimal: 'n',

    },
    {
      ColumnName: 'Payment Doc',
      Value: 'sPaymentDoc',
      Section: 1,
      show: 'n',
      SortField: 'sPaymentDoc',
      Width: '5%',
      Align: 'center',
      Decimal: 'n',

    },
    {
      ColumnName: 'Req. No.',
      Value: 'sRequestID',
      Section: 1,
      show: 'n',
      SortField: 'sRequestID',
      Width: '3%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Type',
      Value: 'sReqType',
      Section: 1,
      show: 'n',
      SortField: 'sReqType',
      Width: '2%',
      Align: 'center',
      Decimal: 'y',
    },
    {
      ColumnName: 'Vendor/Customer',
      Value: 'vendor',
      Section: 1,
      show: 'n',
      SortField: 'vendor',
      Width: '2%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Cost Center',
      Value: 'sCCTR',
      Section: 1,
      show: 'n',
      SortField: 'sCCTR',
      Width: '4%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Net Total',
      Value: 'nGrandTotalAmtInvoice',
      Section: 1,
      show: 'n',
      SortField: 'nGrandTotalAmtInvoice',
      Width: '5%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Due Date',
      Value: 'dDueDate_SSC',
      Section: 1,
      show: 'n',
      SortField: 'dDueDate_SSC',
      Width: '3%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: 'Note',
      Value: 'sDocHeader',
      Section: 1,
      show: 'n',
      SortField: 'sDocHeader',
      Width: '5%',
      Align: 'center',
      Decimal: 'n',
    },
    {
      ColumnName: '',
      Value: '',
      Section: 1,
      show: 'n',
      SortField: '',
      Width: '1%',
      Align: 'center',
      Decimal: 'n',
    }
  ];
  ColumnsSelected: any[] = [];
  IsHeaderSort = '';
  SortDirection = '';
  SortICO = 'fas fa-sort';
  IcoSort = 'fas fa-sort';
  IcoSortDesc = 'fas fa-sort-up';
  IcoSortAsc = 'fas fa-sort-down';
  _ArrDataBind = [];
  sDetailData = '';
  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      {sValue: 10},
      {sValue: 20},
      {sValue: 50},
      {sValue: 100}
    ]
  };
  ExcelData: any;
  isDisableImport = true;
  fileDetail: File;
  _ArrData: any;
  isDisabledSaveAll = true;
  isDisabledSavePaymentDoc = true;
  _AllPaymentDoc: any;
  constructor(
              private http: HttpClient,
              private System: TSFuntionService,
              private _decimalPipe: DecimalPipe,
              private modalService: BsModalService,
              private formBuilder: FormBuilder,
              private SW: SWAlertService,
              private router: Router
  ) { }

  async ngOnInit() {
    await this.getAllPaymentDoc();
    this.ColumnsSelected = this.ColumnsData.filter(e => e.show === 'n');
  }
  async  importFile(event) {
    const target: DataTransfer = <DataTransfer>(event.target);
    this.fileName = target.files[0].name;
    this.fileDetail = target.files[0];
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const workbook = XLSX.read(bstr, { type: 'binary' });
      this.ExcelData = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]],  {raw: false , rawNumbers: true});
    };
     reader.readAsBinaryString(this.fileDetail);
  }
  checkHaveFileUpload() {
    this.isDisableImport = this.ExcelData === undefined;
    return '';
  }
  async readFile() {
    this.System.BlockUI();
    if (this.ExcelData.length > 0) {
      const result = [];
      for (let x = 0; x < this.ExcelData.length; x++) {
        const items = {
          'rowNumber': null,
          'dCreateDate': '',
          'sPaymentDoc': '',
          'sSupportingDocument': '',
          'sRequestID': '',
          'sRequestCode': '',
          'vendor': '',
          'sCCTR': '',
          'nGrandTotalAmtInvoice': null,
          'dDueDate_SSC': '',
          'sDocHeader': '',
          'nYear': null,
          'IsReqUrgent': null,
          'IsVendorGroup': null,
          'sReqType': '',
          'nStatusID': null,
          'show': false,
          'showReplace': false
        };

        items.rowNumber = x;
        items.dCreateDate = this.ExcelData[x]['Create Date'];
        items.sRequestID = this.ExcelData[x]['ReqID'];
        items.nYear = this.ExcelData[x]['Year'];
        items.sPaymentDoc = this.ExcelData[x]['Payment Doc'];
        items.sRequestCode = this.ExcelData[x]['Req. No.'];
        items.sReqType = this.ExcelData[x]['Type'];
        items.vendor = this.ExcelData[x]['Vendor/Customer'];
        items.sCCTR = this.ExcelData[x]['Cost Center'];
        items.nGrandTotalAmtInvoice = this.ExcelData[x]['Net Total'];
        items.dDueDate_SSC = this.ExcelData[x]['Due Date'] ? this.dateFormat(this.ExcelData[x]['Due Date']) : null;
        items.sDocHeader = this.ExcelData[x]['Note'];
        items.nStatusID = this.ExcelData[x]['Status'];
        let replaceResult = [];
        if (this._AllPaymentDoc) {
          replaceResult = this._AllPaymentDoc.filter(f =>
            // tslint:disable-next-line:max-line-length radix
            (typeof f.nStatusID === 'string' ? parseInt(f.nStatusID) : f.nStatusID) === (typeof items.nStatusID === 'string' ? parseInt(items.nStatusID) : items.nStatusID)
            // tslint:disable-next-line:max-line-length radix
            && (typeof f.sCCTR === 'string' ? parseInt(f.sCCTR) : f.sCCTR) === (typeof items.sCCTR === 'string' ? parseInt(items.sCCTR) : items.sCCTR)
            && f.sRequestCode === items.sRequestCode.toString()
            // tslint:disable-next-line:radix max-line-length
            && (typeof f.sRequestID === 'string' ? parseInt(f.sRequestID) : f.sRequestID) === (typeof items.sRequestID === 'string' ? parseInt(items.sRequestID) : items.sRequestID)
          );
          if (replaceResult.length > 0) {
            if (replaceResult[0]['sPaymentDoc']) {
              items.showReplace = true;
            }
          }
        }
        result.push(items);
      }
      this._ArrData = this.dupDataHandle(result);
      this.isDisabledSaveAll = false;
    } else {
      this._ArrData = [];
      this.isDisabledSaveAll = true;
    }
    this.BindDataTable();
  }
  dateFormat(dateData) {
    const date = new Date((dateData - 25569) * 86400 * 1000);
    let result = null;
    if (isNaN(date.getDate())) {
      result = dateData;
    } else {
      result = (date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear();
    }
    return result;

  }
  dupDataHandle(result) {
    const itemCheckDup = result;
    for (let index = 0; index < itemCheckDup.length; index++) {
      const duplicateData = itemCheckDup.filter(f =>
        f.dCreateDate === result[index].dCreateDate &&
        f.sPaymentDoc === result[index].sPaymentDoc &&
        f.sSupportingDocument === result[index].sSupportingDocument &&
        f.sRequestID === result[index].sRequestID &&
        f.sRequestCode === result[index].sRequestCode &&
        f.vendor === result[index].vendor &&
        f.sCCTR === result[index].sCCTR &&
        f.nGrandTotalAmtInvoice === result[index].nGrandTotalAmtInvoice &&
        f.dDueDate_SSC === result[index].dDueDate_SSC &&
        f.sDocHeader === result[index].sDocHeader &&
        f.nYear === result[index].nYear &&
        f.IsReqUrgent === result[index].IsReqUrgent &&
        f.IsVendorGroup === result[index].IsVendorGroup &&
        f.sReqType === result[index].sReqType &&
        f.nStatusID === result[index].nStatusID
      );
      itemCheckDup[index].show = duplicateData.length > 1;
    }
    return itemCheckDup;
  }
  BindDataTable() {
    this.OptionGrid.nTotalItem = this._ArrData.length;
    const nPageSize = this.System.ParseIntToZero(this.OptionGrid.nPageSize);
    const nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * nPageSize;
    const nEndIndex_Take = nPageSize;
    this._ArrDataBind = [];
    this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({}, val)));
    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);
    const nStartItemPage = nStartIndex_Take + 1;
    const nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = 'Showing ' + nStartItemPage + ' to ' + nLastItemPage + ' of ' + this._ArrData.length + ' Rows';
    this.System.UnBlockUI();
  }
  ClearData() {
    window.location.reload();
  }
  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      } else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrDataBind = _.orderBy(this._ArrDataBind, [SortField], [this.SortDirection]);
    }
  }

  showData(value): boolean {
    return value;
  }
  showReplace(status): boolean {
   return status;
  }
  OpensPaymentDoc(templateFiDoc: TemplateRef<any>, numRow) {
    this.sPaymentDocFrom.get('sPaymentDocRowNum').setValue(this._ArrDataBind[numRow]['rowNumber']);
    this.sPaymentDocFrom.get('sPaymentDocReqID').setValue(this._ArrDataBind[numRow]['sRequestID']);
    this.sPaymentDocFrom.get('sPaymentDocReqCode').setValue(this._ArrDataBind[numRow]['sReqType']);
    this.sPaymentDocFrom.controls.sPaymentDoc.setValue(this._ArrDataBind[numRow]['sPaymentDoc']);
    this.modalRef = this.modalService.show(
      templateFiDoc,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  displayFieldCss(_Field: string) {
    return {
      'has-error': this.isFieldValid(_Field),
      'has-feedback': this.isFieldValid(_Field)
    };
  }
  isFieldValid(_Field: string) {
      return !this.sPaymentDocFrom.get(_Field).valid && this.sPaymentDocFrom.get(_Field).touched;
  }
  checkSaveMinimum(_Field: string) {
      if (this.sPaymentDocFrom.get(_Field).value) {
        this.isDisabledSavePaymentDoc = this.sPaymentDocFrom.get(_Field).value.toString().length <= 0;
      } else {
        this.isDisabledSavePaymentDoc = true;
      }
    return '';
  }
  async saveDoc (form) {
    const This = this;
    if (form === 'sPaymentDocFrom') {
      if (this.sPaymentDocFrom.controls.sPaymentDoc !== null || true) {
        this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, this.SW.BoxMsg.Desc_Confirm_Save, function () {
          This._ArrData[This.sPaymentDocFrom.controls.sPaymentDocRowNum.value]
            ['sPaymentDoc'] = This.sPaymentDocFrom.controls.sPaymentDoc.value;
          This._ArrData[This.sPaymentDocFrom.controls.sPaymentDocRowNum.value]['show'] = false;
          This.BindDataTable();
          This.sPaymentDocFrom.reset();
          This.modalRef.hide();
        }, function () {
          Swal.close();
        });
      } else {
        this.sPaymentDocFrom.get('sPaymentDoc').markAsTouched({ onlySelf: true });
      }
    }
  }
  redirect() {
    const This = this;
    this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, 'If you leave this page Unsaved data will be lost.', function () {
      This.router.navigate(['/admin-payment']);
    }, function () {
      Swal.close();
    });
  }
  saveALlTable(type) {
    const This = this;
    const item = This._ArrData;
    let validate = true;
    for (let x = 0; x < item.length; x++) {
        if (item[x]['sPaymentDoc'] !== undefined) {
          if (item[x]['sPaymentDoc'].toString().length > 0) {
            item[x]['show'] = false;
          } else {
            item[x]['show'] = true;
            validate = false;
          }
        } else {
          item[x]['show'] = true;
          validate = false;
        }
    }
    const falseResult = item.filter(val => val.show === true).length;
    if (falseResult > 0) {
      validate = false;
    }
    This._ArrData = item;
    This.BindDataTable();
    const saveDataProcess = function () {
      const paymentImportBody = [];
      for (let x = 0; x < This._ArrData.length; x++) {
        const itemToSave = {
          sRequestID : '',
          sRequestCode : '',
          sPaymentDoc : '',
          nYear : null,
        };
        itemToSave.sRequestID = This._ArrData[x]['sRequestID'].toString();
        itemToSave.sRequestCode = This._ArrData[x]['sRequestCode'] ? This._ArrData[x]['sRequestCode'].toString() : null;
        itemToSave.sPaymentDoc = This._ArrData[x]['sPaymentDoc'].toString();
        // tslint:disable-next-line:radix
        itemToSave.nYear = parseInt(This._ArrData[x]['nYear']);
        paymentImportBody.push(itemToSave);
      }

      const mergeData = {
        paymentImportBody,
        nType: type
      };
      const prepareToRequest = [];
      prepareToRequest.push(mergeData);
      const saveAllTableData = JSON.stringify(prepareToRequest);
      const headers = new HttpHeaders({
        'Content-Type': 'application/json'
      });
      This.http.post(This.System.SiteName + 'api/AdminPayment/SaveAllTable', saveAllTableData, {
        headers,
        responseType: 'text' ,
      }).subscribe(result => {
        This.System.UnBlockUI();
        if (result === 'Success') {
          This.SW.SwAlert.Success(This.SW.BoxMsg.Title_Success, 'Data is already saved.', function () {
            This.ClearData();
          });
        }
      });
    };
    if (validate) {
      if (type === 0) {
        this.SW.SwAlert.Confirm0(this.SW.BoxMsg.Title_Confirm, 'Do you want to import data?', saveDataProcess, function () {
        });
      } else {
        this.SW.SwAlert.Confirm1(this.SW.BoxMsg.Title_Confirm, 'Do you want to import data?', saveDataProcess, function () {
        });
      }
    } else {
      this.SW.SwAlert.Error('Error, Checking Alert', 'Please check, some items are incorrect.', undefined);
    }
  }
  checkIsNumber(value) {
    return isNaN(value) === false;
  }
  _RowResult(decimal, value) {
    return (decimal === 'y' && value !== null) ? this._ConvertToDecimal(value) : value;
  }
  _ConvertToDecimal(sVal) {
    const NoComma = (sVal + '').replace(/,/g, ''); // ตัด Comma ออก
    return this._decimalPipe.transform(NoComma, '1.2-2');
  }
  deleteRow(index) {
    const This = this;
    this.SW.SwAlert.Confirm(this.SW.BoxMsg.Title_Confirm, 'Do you want to remove data?', function () {
      const itemToDelete = This._ArrData;
      itemToDelete.splice(index, 1);
      for (let x = 0; x < itemToDelete.length; x++) {
        itemToDelete[x]['rowNumber'] = x;
      }

      This._ArrData = This.dupDataHandle(itemToDelete);
      This.BindDataTable();
    }, function () {
      Swal.close();
    });
  }
  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }
  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });
  }
  CheckNoDub() {
    if (this._ArrData) {
      const checkFail = this._ArrData.filter(f => f.show === true);
      this.isDisabledSaveAll = checkFail.length > 0;
    }
    return '';
  }

  async getAllPaymentDoc() {
    this.http.get<any>(this.System.SiteName + 'api/AdminPayment/GetAllPaymentDoc').toPromise().then(res => {
      this._AllPaymentDoc = res;
    });
  }

}
